module.exports = __webpack_public_path__ + "img/get-score.b582f021.svg";